(() => {
  /**
   * Hover Mega Menu for Shopify Dawn
   * - Desktop (mouse) par hover => open
   * - Mouse leave => close (delay ke sath)
   * - Click outside / ESC => close (optional)
   *
   * OPTIONS (aap yahan change kar sakte ho)
   */
  const OPTIONS = {
    desktopMinWidth: 990,        // Dawn desktop breakpoint
    openDelay: 80,               // ms
    closeDelay: 180,             // ms
    closeOnClickOutside: true,
    closeOnEscape: true,
    openOnFocus: false,          // keyboard focus par auto-open (optional)
    onlyMegaMenuClass: false     // true = sirf details.mega-menu par apply
  };

  const DESKTOP_MQ = window.matchMedia(
    `(min-width: ${OPTIONS.desktopMinWidth}px) and (hover: hover) and (pointer: fine)`
  );

  function getMenuRoot() {
    // Dawn header inline menu container
    const header = document.querySelector('header');
    if (!header) return null;
    return header.querySelector('.header__inline-menu');
  }

  function closeAll(detailsList) {
    detailsList.forEach(d => {
      if (d.open) d.open = false;
    });
  }

  function initHoverMenus() {
    // Run only on desktop mouse devices
    if (!DESKTOP_MQ.matches) return;

    const menuRoot = getMenuRoot();
    if (!menuRoot) return;

    // Pick all dropdown/mega menus (details) inside header menu
    let detailsList = Array.from(menuRoot.querySelectorAll('details'));

    if (OPTIONS.onlyMegaMenuClass) {
      detailsList = detailsList.filter(d => d.classList.contains('mega-menu'));
    }

    if (!detailsList.length) return;

    detailsList.forEach(details => {
      if (details.dataset.hoverMegaInit === '1') return;
      details.dataset.hoverMegaInit = '1';

      let openTimer = null;
      let closeTimer = null;

      const openMenu = () => {
        // Close others
        detailsList.forEach(d => {
          if (d !== details && d.open) d.open = false;
        });
        // Open this
        if (!details.open) details.open = true;
      };

      const closeMenu = () => {
        if (details.open) details.open = false;
      };

      const scheduleOpen = () => {
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        openTimer = setTimeout(openMenu, OPTIONS.openDelay);
      };

      const scheduleClose = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          // Agar mouse wapas aa gaya ho ya focus andar ho to close na karo
          const active = document.activeElement;
          if (details.matches(':hover')) return;
          if (active && details.contains(active)) return;
          closeMenu();
        }, OPTIONS.closeDelay);
      };

      // Hover behavior
      details.addEventListener('mouseenter', scheduleOpen);
      details.addEventListener('mouseleave', scheduleClose);

      // Optional: focus behavior (keyboard users)
      if (OPTIONS.openOnFocus) {
        details.addEventListener('focusin', () => {
          clearTimeout(closeTimer);
          openMenu();
        });
        details.addEventListener('focusout', () => {
          // close when focus goes out of details
          setTimeout(() => {
            const active = document.activeElement;
            if (!active || !details.contains(active)) scheduleClose();
          }, 0);
        });
      }
    });

    // Close on click outside
    if (OPTIONS.closeOnClickOutside && !window.__hoverMegaOutsideClickAdded) {
      window.__hoverMegaOutsideClickAdded = true;

      document.addEventListener(
        'click',
        (e) => {
          const menuRootNow = getMenuRoot();
          if (!menuRootNow) return;

          // If click not inside header menu => close all
          if (!menuRootNow.contains(e.target)) {
            const allDetails = Array.from(menuRootNow.querySelectorAll('details'));
            closeAll(allDetails);
          }
        },
        true
      );
    }

    // Close on ESC
    if (OPTIONS.closeOnEscape && !window.__hoverMegaEscAdded) {
      window.__hoverMegaEscAdded = true;

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const menuRootNow = getMenuRoot();
        if (!menuRootNow) return;
        const allDetails = Array.from(menuRootNow.querySelectorAll('details'));
        closeAll(allDetails);
      });
    }
  }

  // Init on load
  document.addEventListener('DOMContentLoaded', initHoverMenus);

  // Shopify theme editor support (section reloads)
  document.addEventListener('shopify:section:load', initHoverMenus);

  // If viewport changes desktop<->mobile
  if (DESKTOP_MQ.addEventListener) {
    DESKTOP_MQ.addEventListener('change', () => {
      // When leaving desktop, close open menus
      const menuRoot = getMenuRoot();
      if (!menuRoot) return;
      closeAll(Array.from(menuRoot.querySelectorAll('details')));
      initHoverMenus();
    });
  } else if (DESKTOP_MQ.addListener) {
    DESKTOP_MQ.addListener(() => {
      const menuRoot = getMenuRoot();
      if (!menuRoot) return;
      closeAll(Array.from(menuRoot.querySelectorAll('details')));
      initHoverMenus();
    });
  }
})();